var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-3"},[_vm._v("Expediente")]),_c('b-card',[_c('alert',{attrs:{"variant":_vm.alert.variant,"dismissible":"","mensagens":_vm.alert.mensagens,"value":_vm.alert.exibir},on:{"input":_vm.alertDismissed}}),_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('editor',{attrs:{"init":{                               
                    language: 'pt_BR',
                    license_key: 'gpl',
                    base_url: '/js/tinymce',
                    height: 550,
                    menubar: false,
                    branding: false,
                    paste_as_text: false,
                    paste_merge_formats: true,
                    plugins: [
                        'lists',
                        'autolink',
                        'link',
                        'preview',
                        'searchreplace',
                        'table',
                        'wordcount',
                    ],
                    toolbar: [
                        'bold italic underline strikethrough fontfamily blocks fontsize forecolor backcolor bullist numlist subscript superscript removeformat',
                        'alignleft aligncenter alignright alignjustify outdent indent table link undo redo preview customUploadWord'
                    ], 
                    setup: function(ed) {
                        ed.on('keydown', function(event) {
                            if (event.keyCode == 9) { // tab pressed
                                if (event.shiftKey) {
                                ed.execCommand('Outdent');
                                }
                                else {
                                ed.execCommand('Indent');
                                }

                                event.preventDefault();
                                return false;
                            }
                        });
                    }
                }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1),_c('b-row',[_c('b-col',{staticClass:"text-right"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.salvar}},[_c('i',{staticClass:"fa fa-floppy-o pr-1"}),_vm._v(" Salvar ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }